var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAds)?_c('div',{staticClass:"text-center pb-2 ads-wrapper"},[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":_vm.adClient,"data-ad-slot":_vm.adSlot,"data-ad-format":"auto","data-adtest":"on","data-full-width-responsive":"true"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }